// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"dc4ab236","732":"e9bfda76","867":"ea1e35d8"}[chunkId] + ".chunk.js";
};